import { render } from "./PolicyModal.vue?vue&type=template&id=52166945&scoped=true"
import script from "./PolicyModal.vue?vue&type=script&lang=js"
export * from "./PolicyModal.vue?vue&type=script&lang=js"

import "./PolicyModal.vue?vue&type=style&index=0&id=52166945&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52166945"]])

export default __exports__